export default {
  title: '隐私政策',
  docTitle: 'BetCorgi 隐私政策',
  docSubtitle: '了解我们如何保护和使用您的信息',
  intro: '我们遵循必要、明确和安全原则处理您的信息。本政策说明信息如何被收集、使用、保存及保护。',
  s1Title: '我们收集的信息',
  s1Body:
    '可能包括账号资料、绑定手机或邮箱、身份核验资料、设备与登录信息、充值提现记录、收款账户、操作日志及为完成服务所必需的其他信息。',
  s2Title: '信息使用目的',
  s2Body:
    '用于创建和管理账号、完成交易与身份核验、保障账号及资金安全、识别欺诈风险、提供客服、处理争议、优化产品以及履行适用的合规义务。',
  s3Title: '信息共享',
  s3Body:
    '仅在完成支付、身份认证、技术服务、风险控制或依法配合监管所必要的范围内，与经审慎选择的合作方共享。我们不会出售您的个人信息。',
  s4Title: '存储与安全',
  s4Body:
    '我们采取访问控制、传输加密、风险监测及数据最小化等措施保护信息，并在实现目的或法律要求的必要期限内保存；期满后将删除或匿名化处理。',
  s5Title: '您的权利',
  s5Body:
    '您可以在账号或安全中心查看、更正部分资料，管理绑定方式及授权；也可联系客服申请访问、更正、删除或注销账号。为保障安全，我们可能先核验身份。',
  s6Title: '设备信息与本地存储',
  s6Body:
    '为保持登录状态、保存界面偏好和改善体验，可能使用 Cookie 或本地存储。关闭后部分功能可能无法正常工作，您可通过设备或浏览器设置进行管理。',
  s7Title: '未成年人保护',
  s7Body:
    '平台仅向已满 18 周岁的用户提供服务。若发现未成年人信息被误收集，请联系我们核实并及时处理。',
  s8Title: '政策更新与联系',
  s8Body:
    '重大变更将通过显著提示或站内消息告知。若对个人信息处理有疑问或希望行使相关权利，可联系在线客服。',
  done: '我已阅读',
}
